export default __webpack_public_path__ + "assets/upload_logo_market_guideline.f28fed.png";